(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/prolong.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/prolong.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.prolong = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "    <div class=\"f-bold margin-top-1 margin-bottom-2 ta-center fc-grey-600\">\n        Notera att pågående spel inte kan förlängas\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasOngoingGames") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"maltipset-prolong-list-container bg-white\">\n    <div class=\"prolong-header f-bold padding-1 fc-grey-600\">\n        Avgjorda spel\n    </div>\n    <div class=\"prolong-list-wrap\"></div>\n    <div class=\"more-items-loader\"></div>\n</div>";
},"useData":true});
Handlebars.partials['svs-maltipset-prolong'] = svs.maltipset.templates.prolong;
})(svs, Handlebars);


 })(window);